import { Component, OnInit, Input, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { SiteType } from 'src/api/models';
import { DashboardComponent } from 'src/app/views/dashboard/dashboard.component';

@Component({
    selector: 'dashboard-tabs',
    templateUrl: './dashboard-tabs.component.html',
    styleUrls: ['./dashboard-tabs.component.css'],
    
})
export class DashboardTabsComponent implements OnInit, AfterViewInit {
    @ViewChildren(DashboardComponent) private dashboards: QueryList<DashboardComponent>;
    @Input() siteType: SiteType;
    @Input() siteUri: string;

    
    constructor() {
        
    }

    ngOnInit() {
    
    }

    ngAfterViewInit(): void {
        if (this.dashboards){
            setTimeout(() => {
                for (let dashboard of this.dashboards){
                    (dashboard as DashboardComponent).loadWidgets();
                }
            }, 1000);
        }
    }
}
